import script from "./depositView.vue?vue&type=script&setup=true&lang=ts"
export * from "./depositView.vue?vue&type=script&setup=true&lang=ts"

import "./depositView.vue?vue&type=style&index=0&id=fc50f57a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc50f57a"]])

export default __exports__